<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">{{ title }}</h3>
                </div>
                <div class="col text-right">
                    <base-button @click.prevent="filterModal = true;" type="primary">
                        Spalten ein/ausblenden
                    </base-button>
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 250px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <modal v-model:show="modal" modal-classes="modal-xl modal-dialog-centered modal-dialog-scrollable">
            <template v-slot:header></template>
            <div class="card mt--2">
                <vue-pdf-embed :source="pdf"/>
            </div>
            <template v-slot:footer>
                <!--                <base-button @click.prevent="modal = false;" type="primary">
                                    <span class="fad fa-times mr-1"/> Schliessen
                                </base-button>-->
                <base-button @click.prevent="downloadInvoice" type="primary">
                    <span class="fad fa-download mr-1"/> Download
                </base-button>
            </template>
        </modal>
        <div class="table-responsive">
            <el-table @row-click="getInvoice($event)"
                      type="index"
                      ref="invoicesTable"
                      class="table-responsive clickableRow"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'status', order: 'descending' }"
                      empty-text="Keine Einträge vorhanden"
                      :span-method="spanMethod"
                      @sort-change="changeSort"
                      :data="filteredInvoices">
                <el-table-column prop="receiptId" label="Rechnungsnummer" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.receiptId.visible">
                    <template v-slot="{ row }">
                        <template v-if="loadingId === row.receiptId">
                            <div class="loaderInfo"><img class="loader" src="img/loading.gif" alt="loader"></div>
                        </template>
                        <template v-else class="text-center">
                            {{ (row.receiptId) ? row.receiptId : '' }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="debitorDate" label="Datum" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.debitorDate.visible">
                    <template v-slot="{ row }">
                        {{ (row.debitorDate) ? row.debitorDate : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="dueDate" label="Fälligkeit" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.dueDate.visible">
                    <template v-slot="{ row }">
                        {{ (row.dueDate) ? row.dueDate : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="Status" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.status.visible">
                    <template v-slot="{ row }">
                        {{ (row.status) ? row.status : '' }} <i
                        :class="{'fad fa-check-circle text-success': (row.status == 'Erledigt'), 'fad fa-file-invoice text-danger': (row.status != 'Erledigt')}"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="Betrag" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.amount.visible">
                    <template v-slot="{ row }">
                        {{
                            (row.amount) ? parseFloat(row.amount).toLocaleString('de-CH', {
                                style: 'currency',
                                currency: 'CHF'
                            }) : ''
                        }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <base-button class="exportCSV" title="exportieren" @click.prevent="exportCSV()"
                         type="success">
                exportieren
            </base-button>
            <div class=""
                 :class="type === 'dark' ? 'bg-transparent': ''">
                <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
            </div>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
    <modal v-model:show="filterModal" @close="filterModal = false"
           modal-classes="modal-sm modal-dialog-centered d-flex justify-content-center">

        <div v-for="(column, key) in table" class="ml-3">
            <el-checkbox v-model="table[key].visible" :label="column.header"></el-checkbox>
        </div>
        <base-button class="resetFilter ml-3" title="zurücksetzen" @click.prevent="resetTableColumns()"
                     type="warning">
            Zurücksetzen
        </base-button>

        <div class="row ">
        </div>
    </modal>
</template>
<script>
import moment from 'moment';
import UserService from '@/services/user.service';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import VuePdfEmbed from 'vue-pdf-embed';
import * as jsonexport from "jsonexport/dist";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption,
    ElCard,
    ElCheckbox,
} from "element-plus";
import BaseButton from "../../components/BaseButton";

export default {
    name: 'invoices-table',
    components: {
        BaseButton,
        Modal,
        BaseAlert,
        VuePdfEmbed,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElCard.name]: ElCard,
        [ElCheckbox.name]: ElCheckbox,
    },
    props: {
        type: {
            type: String
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredInvoices() {
            if (this.search === '') {
                this.total = this.invoices.length;
                return this.invoices.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.invoices.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        spanMethod({row, column, rowIndex, columnIndex}) {
            if (this.loadingId === row.receiptId) {
                if (columnIndex === 0) {
                    return [1, 6]
                } else {
                    return [0, 0]
                }
            }
        },
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.invoices.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (this.currentSort.includes('Id') || this.currentSort === 'amount') {
                    if (parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
                    if (parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
                }
                if (this.currentSort.toLowerCase().includes('date')) {
                    if (a[this.currentSort].split('.').reverse().join('') < b[this.currentSort].split('.').reverse().join('')) return -1 * modifier;
                    if (a[this.currentSort].split('.').reverse().join('') > b[this.currentSort].split('.').reverse().join('')) return modifier;
                }
                if (this.currentSort === 'status') {
                    return ((a[this.currentSort].toLowerCase().localeCompare(b[this.currentSort].toLowerCase()) * modifier) || a['dueDate'].split('.').reverse().join('') - b['dueDate'].split('.').reverse().join(''));
                }
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getInvoices() {
            UserService.getInvoices().then(
                response => {
                    this.invoices = response.data.data;
                    this.sortTable();
                    this.total = response.data.recordsTotal;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getInvoice(invoice) {
            if(invoice.source === 0) {
                this.getInvoice0(invoice.receiptId);
            } else {
                this.getInvoice1(invoice.receiptId);
            }
        },
        getInvoice0(id) {
            if (this.loadingId !== id) {
                this.loadingId = id;
                UserService.getInvoice(id).then(
                    response => {
                        const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                        this.pdf = url;
                        const link = document.createElement('a');
                        link.href = url;
                        link.target = '_blank'
                        link.setAttribute('download', 'rechnung_' + this.loadingId + '.pdf');
                        document.body.appendChild(link);
                        this.downloadLink = link;
                        this.loadingId = 0;
                        this.loadingFId = 0;
                        this.modal = true;
                    }
                );
            }
        },
        getInvoice1(id) {
            if (this.loadingId !== id) {
                this.loadingId = id;
                UserService.getInvoiceREST(id).then(
                    response => {
                        const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                        this.pdf = url;
                        const link = document.createElement('a');
                        link.href = url;
                        link.target = '_blank'
                        link.setAttribute('download', 'rechnung_' + this.loadingId + '.pdf');
                        document.body.appendChild(link);
                        this.downloadLink = link;
                        this.loadingId = 0;
                        this.loadingFId = 0;
                        this.modal = true;
                    }
                );
            }
        },
        downloadInvoice() {
            this.downloadLink.click();
        },
        exportCSV() {
            let exported = []
            for (const invoice of this.invoices) {
                let data = {}
                for (const e in this.table) {
                    if (this.table[e].visible) {
                        data[this.table[e].CSVHeader] = invoice[e];
                    }
                }
                exported.push(data);
            }
            jsonexport(exported, {rowDelimiter: ';'}, (err, csv) => {
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/csv;charset=utf-16,' + encodeURIComponent(csv));
                element.setAttribute('download', 'Rechnungen.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
        },
        getTableColumns() {

            if (sessionStorage.getItem('invoicesTable') !== null) {
                return JSON.parse(sessionStorage.getItem('invoicesTable'));
            } else {
                return {
                    receiptId: {visible: true, header: 'Rechnungsnummer', key: 'receiptId', CSVHeader: 'Rechnungsnummer'},
                    debitorDate: {visible: true, header: 'Datum', key: 'debitorDate', CSVHeader: 'Datum'},
                    dueDate: {visible: true, header: 'Fälligkeit', key: 'dueDate', CSVHeader: 'Fälligkeit'},
                    status: {visible: true, header: 'Status', key: 'status', CSVHeader: 'Status'},
                    amount: {visible: true, header: 'Betrag', key: 'amount', CSVHeader: 'Betrag'},
                };
            }
        },

        resetTableColumns() {
            this.table = {
                receiptId: {visible: true, header: 'Rechnungsnummer', key: 'receiptId', CSVHeader: 'Rechnungsnummer'},
                debitorDate: {visible: true, header: 'Datum', key: 'debitorDate', CSVHeader: 'Datum'},
                dueDate: {visible: true, header: 'Fälligkeit', key: 'dueDate', CSVHeader: 'Fälligkeit'},
                status: {visible: true, header: 'Status', key: 'status', CSVHeader: 'Status'},
                amount: {visible: true, header: 'Betrag', key: 'amount', CSVHeader: 'Betrag'},
            };
            sessionStorage.removeItem('invoicesTable');
        }
    },
    created() {
        this.getInvoices();
        this.table = this.getTableColumns();
    },
    data() {
        return {
            invoices: [],
            downloadLink: null,
            currentSort: 'status',
            currentSortDir: 'descending',
            loadingId: 0,
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            errorText: '',
            modal: false,
            pdf: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 10,
            table: {},
            filterModal: false,
        }
    },
    watch: {
        modal() {
            if (!this.modal && this.downloadLink != null) {
                this.downloadLink.remove();
            }
        },
        pagination() {
            this.start = (this.pagination - 1) * this.perPage;
        },
        table: {
            handler(value) {
                sessionStorage.setItem('invoicesTable', JSON.stringify(value));
            }, deep: true
        },
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.loader {
    height: 100%;
}

.loaderInfo {
    padding: 0;
    margin: 0;
    background: white;
    height: 4em;
}

.ck-editor__editable {
    min-height: 150px;
}

.errorText {
    color: #f5365c;
}

thead th {
    cursor: pointer;
}
</style>
<style lang="scss">

canvas {
    height: auto !important;
}
.exportCSV {
    line-height: 0.5!important;
    height: 36px;
    overflow: hidden!important;
}
</style>
